import { Avatar, Box, Card, Group, Table, Text, Title } from '@mantine/core';
import React from 'react';
interface SMESData {
  name: string;
  email: string;
  division: string;
  binusianID: string;
}
interface SubjectMatterExpertsProps {
  smes: SMESData[];
}
const SubjectMatterExperts: React.FC<SubjectMatterExpertsProps> = ({ smes }) => {
  return (
    <Card withBorder radius='lg' padding='lg'>
      <Group justify='space-between' mb='md'>
        <Title order={4}>Subject Matter Experts (SMEs)</Title>
      </Group>

      {smes.length > 0 ? (
        <Table>
          <Table.Thead>
            <Table.Tr>
              <Table.Th>Name</Table.Th>
              <Table.Th>Email</Table.Th>
              <Table.Th>Division</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {smes.map((sme: any, index: number) => (
              <Table.Tr key={index}>
                <Table.Td>
                  <Group>
                    <Avatar color='#7B2183' radius='xl'>
                      {sme.name ? sme.name.charAt(0) : 'S'}
                    </Avatar>
                    <Box>
                      <Text size='sm' fw={500}>
                        {sme.name || sme.binusianID || 'Unknown'}
                      </Text>
                      <Text size='xs' c='dimmed'>
                        {sme.binusianID || sme.email || 'No ID available'}
                      </Text>
                    </Box>
                  </Group>
                </Table.Td>
                <Table.Td>{sme.email || 'No email available'}</Table.Td>
                <Table.Td>{sme.division || 'N/A'}</Table.Td>
              </Table.Tr>
            ))}
          </Table.Tbody>
        </Table>
      ) : (
        <Text c='dimmed' ta='center'>
          No Subject Matter Experts assigned to this assessment.
        </Text>
      )}
    </Card>
  );
};

export default SubjectMatterExperts;
